"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueOrArrayToArray = valueOrArrayToArray;
/**
 * Makes sure that the value is an array. If the value is not an array, it will be wrapped in an array.
 *
 * @param value - The value to convert to an array if it is nota lready an array.
 * @returns {Array<T>} - The value as an array.
 */
function valueOrArrayToArray(value) {
    if (Array.isArray(value)) {
        return value;
    }
    return [value];
}
//# sourceMappingURL=value-or-array-to-array.js.map